<section
  class="grid content-center items-center gap-10 py-8 lg:min-h-[70vh] lg:grid-cols-2 lg:py-16"
>
  <div class="flex flex-col gap-6 text-left">
    <h1 class="flex flex-col gap-1">
      <span class="text-3xl font-bold text-brand sm:text-4xl"
        >Spinning Heracles</span
      >
      <span class="text-lg font-semibold text-fg-muted">Westerlo</span>
    </h1>

    <p class="max-w-prose text-lg text-fg-muted">
      Ruime keuze aan lesmomenten en lesgevers, van beginner tot ervaren.
      Reserveer je fiets online en kom sporten op je eigen tempo.
    </p>

    <ul
      role="list"
      class="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-x-6"
    >
      @for (point of sellingPoints; track point) {
        <li class="flex items-center gap-2">
          <app-icon name="check" size="size-4" class="shrink-0 text-brand" />
          <span class="font-semibold text-fg">{{ point }}</span>
        </li>
      }
    </ul>

    <div class="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
      @if (userLoggedIn$ | async) {
        <button appButton type="button" (click)="navigateToReservePage()">
          <app-icon name="arrow-right" size="size-4" />
          Reserveren
        </button>
      }
      <button
        appButton
        variant="secondary"
        type="button"
        (click)="navigateToInfoPage()"
      >
        <app-icon name="info" size="size-4" />
        Uren en tarieven
      </button>
      @if ((userLoggedIn$ | async) === false) {
        <button appButton type="button" (click)="navigateToProeflesPage()">
          <app-icon name="star" size="size-4" />
          Gratis proefles
        </button>
      }
    </div>
  </div>

  <img
    src="assets/images/spinningintro.png"
    alt="Spinningzaal bij Heracles Westerlo"
    class="w-full rounded-card object-cover shadow-lg"
  />
</section>
